import { API } from "config/API"

export const getAllPermissions = async () => {
  const response = await API.get("/permissions/all")
  return response
}
